/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { PlayerProfileLink } from 'widgets/statspro/js/components/common/PlayerProfileLink';

/**
 * Renders a list of player milestone links with milestone event descriptions and comma separation.
 *
 * @param {object} props - Component props.
 * @param {Array} [props.milestones] - Array of milestone items.
 * @param {boolean} [props.isAFLW] - Whether the competition is AFLW.
 * @param {string} [props.clubId] - Club identifier.
 * @param {string} [props.trackingContentType] - Analytics tracking content type.
 * @returns {React.JSX.Element} The list of milestones or fallback dash.
 */
export const TAMilestoneList = ({
    milestones,
    isAFLW,
    clubId,
    trackingContentType
}) => {
    if (!milestones || milestones.length === 0) {
        return <span>-</span>;
    }

    const { EVENTS, VALUES } = PULSE.app.common.CONSTANTS.TRACKING;

    return milestones.map((item, index) => {
        const { player, milestoneEvent } = item || {};
        const givenName = player?.playerName?.givenName;
        const surname = player?.playerName?.surname;

        return (
            <React.Fragment key={player?.playerId || index}>
                <PlayerProfileLink
                    classes="team-announcements__link"
                    player={{
                        playerId: player?.playerId,
                        firstName: givenName,
                        surname: surname
                    }}
                    trackingInfo={{
                        event: EVENTS.SELECT.LINK,
                        component_name: VALUES.TEAM_LINEUPS.VIEW.FIELD,
                        component_content_type: trackingContentType
                    }}
                    isAFLW={isAFLW}
                    clubId={clubId}
                >
                    <span>
                        {givenName} {surname}
                    </span>
                </PlayerProfileLink>
                <span>
                    {milestoneEvent ? ` (${milestoneEvent})` : null}
                    {index + 1 !== milestones.length ? ', ' : ' '}
                </span>
            </React.Fragment>
        );
    });
};

TAMilestoneList.propTypes = {
    milestones: PropTypes.array,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.string,
    trackingContentType: PropTypes.string
};
